import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10e9129c")

_pushScopeId("data-v-10e9129c")
const _hoisted_1 = { class: "vectoric-button" }
const _hoisted_2 = {
  viewBox: "0 0 42 42",
  class: "doughnut"
}
const _hoisted_3 = {
  key: 0,
  x: "50%",
  y: "50%",
  class: "icon-element"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseDown && _ctx.onMouseDown(...args))),
    onMouseup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
    onMouseout: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock("svg", _hoisted_2, [
        _createVNode("circle", {
          class: "doughnut-hole",
          cx: _ctx.svgCx,
          cy: _ctx.svgCy,
          r: _ctx.svgRadius
        }, null, 8, ["cx", "cy", "r"]),
        _createVNode("circle", {
          class: "doughnut-ring",
          cx: _ctx.svgCx,
          cy: _ctx.svgCy,
          r: _ctx.svgRadius,
          stroke: _ctx.doughnutRingColor
        }, null, 8, ["cx", "cy", "r", "stroke"]),
        _createVNode("circle", {
          class: "doughnut-segment",
          stroke: _ctx.doughnutSegmentColor,
          "stroke-dasharray": _ctx.relativeFill,
          cx: _ctx.svgCx,
          cy: _ctx.svgCy,
          r: _ctx.svgRadius
        }, null, 8, ["stroke", "stroke-dasharray", "cx", "cy", "r"]),
        (_ctx.loadedIconToUse)
          ? (_openBlock(), _createBlock("svg", _hoisted_3, [
              _createVNode("image", {
                "xlink:href": _ctx.loadedIconToUse,
                height: "27",
                width: "27",
                transform: "translate(-13.5, -13.5)"
              }, null, 8, ["xlink:href"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("circle", {
          class: "doughnut-border",
          stroke: _ctx.doughnutBorderColor,
          cx: _ctx.svgCx,
          cy: _ctx.svgCy,
          r: _ctx.svgRadius + 2.4
        }, null, 8, ["stroke", "cx", "cy", "r"])
      ]))
    ])
  ], 32))
})